import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'

export const modalStyle = {
  mt: 10,
  bgcolor: 'background.paper',
  border: '1px solid #000',
  boxShadow: 24,
  p: 4,
  overflowY: 'auto',
  maxHeight: 'calc(100% - 80px)', // Subtract some pixels for margin
}

type ConfirmationDialogProps = {
  label: string
  text: string
  open?: boolean
  onSelect: (v: boolean) => void
}
export const ConfirmationDialog = ({label, text, open, onSelect}: ConfirmationDialogProps) => {
  return (
    <Dialog open={open || false} onClose={() => onSelect(false)} aria-labelledby={label}>
      <DialogTitle id="alert-dialog-title">{label}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">{text}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => onSelect(true)}>Yes</Button>
        <Button onClick={() => onSelect(false)} autoFocus>
          No
        </Button>
      </DialogActions>
    </Dialog>
  )
}
